module.exports = __webpack_public_path__ + "img/mainsail_logo.png";